var app = angular.module('leonardo');

var TokenRefresh = function($rootScope, AuthService, ngDialog, $interval , $timeout, $state, $filter,
                            BroadcastChannelService) {
  $rootScope.showMessageLogout = false;
  $rootScope.intervalActivity = null;
  $rootScope.isRefreshingToken = false;

  const MAX_32_BIT_SIGNED = 2147483647;

  var checkActivity = function () {
    if (AuthService.hasToken() && !$rootScope.showMessageLogout) {
      $rootScope.showMessageLogout = true;
      ngDialog.openConfirm({
        template: 'views/templates/dialog/activity.html',
      }).then(function () {
        $rootScope.showMessageLogout = false;
        AuthService.refreshToken().then(function (){
          // This is intentional do_something blank function
          $timeout(() => {
            BroadcastChannelService.postMessage({
              type: 'refresh-token',
              message: 'User token refresh'
            });
          }, 10);
        }).catch(function (){
          showLogout();
        });
      }, function (not_redirect) {
        $rootScope.showMessageLogout = false;
        if (!not_redirect) {
          AuthService.logout();
        }
      });
      $timeout(function () {
        if($rootScope.showMessageLogout){
          ngDialog.closeAll(true);
          setTimeout(() => {
            showLogout();
          }, 0);
        }
        }, 120000);
    }
  };

  var showLogout = function (invalid) {
    if (!$rootScope.showMessageLogout) {
      $rootScope.showMessageLogout = true;
      const message = invalid ?
        $filter('translate')('The user token is no longer valid. You can log back into the app to continue.') :
        $filter('translate')('Your session has expired due to inactivity. You can log back into the app to continue.')
      ngDialog.openConfirm({
        template: 'views/templates/dialog/logout.html',
        data: {
          message: message
        }
      }).then(function () {
        $rootScope.showMessageLogout = false;
        AuthService.logout(invalid);
      }, function () {
        $rootScope.showMessageLogout = false;
        AuthService.logout(invalid);
      });
    }
  };

  var getTimeLifeToken = function (){
    var token = AuthService.getDecodedToken();
    var now = new Date().getTime() / 1000;
    var timeLimit = 120 // 2min
    var exp = now + (3600*24);   // 24hrs is Default expiration time if token is null 
    var timeLife = !isNull(token) ? (token['exp'] - now - timeLimit) : exp - now - timeLimit;
    return parseInt(timeLife * 1000);
  }

  var restartIntervalActivity = function () {
    var time = getTimeLifeToken(); // 2min before token expired
    time = time > MAX_32_BIT_SIGNED ? MAX_32_BIT_SIGNED : time;
    $interval.cancel($rootScope.intervalActivity);
    $rootScope.intervalActivity = $interval(checkActivity, time);
  }

  $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
    if (toParams.public || toParams['#']?.includes('ngdialog')) return;
    var authenticated = AuthService.hasToken();
    if (!authenticated || (toState.name === "logout")) return;

    if (AuthService.tokenExpired()) {
      showLogout();
      event.preventDefault();
    }
    else {

      if (AuthService.token50TimeLife() && !$rootScope.isRefreshingToken) {
        $rootScope.isRefreshingToken = true;
        AuthService.refreshToken().then(function(){
          restartIntervalActivity();
          $timeout(() => {
            BroadcastChannelService.postMessage({
              type: 'refresh-token',
              message: 'User token refresh'
            });
          }, 10);
          $rootScope.isRefreshingToken = false;
          $state.go(toState, toParams)
        }).catch(function (error){
          if (error.xhrStatus !== "abort" || error.status !== -1) {
            $rootScope.isRefreshingToken = false;
            showLogout();
          }
        });
        event.preventDefault();
      }
      else {
        restartIntervalActivity();
      }
    }
  });

  $rootScope.$on('token-auth:deleted', function () {
    // Drop the rejected credentials before anything else: showLogout() defers
    // the actual logout until the dialog is dismissed, and an unattended dialog
    // would otherwise leave the stale token driving requests indefinitely.
    AuthService.invalidateSession();

    if ($rootScope.isInIframe) {
      return;
    }
    showLogout(true);
  });

  var broadcastChannel = {
    onBroadcastChannelMessage: function (message) {
      if (!message.type) {
        return;
      }

      switch (message.type) {
        case 'refresh-token':
          ngDialog.closeAll(true);
          restartIntervalActivity();
          return;
        case 'logout':
          ngDialog.closeAll(true);
          return;
      }
    }
  };

  BroadcastChannelService.subscribe(broadcastChannel);
};

app.run(['$rootScope', 'AuthService', 'ngDialog', '$interval', '$timeout', '$state', '$filter',
  'BroadcastChannelService', TokenRefresh]);
